module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/LadiesinLavender-448x252.f13d82b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/LadiesinLavender-448x252.jpg
// module id = vQTq
// module chunks = 0